<soft-ds-date-range-dropdown size="lg"
                             variant="outline"
                             [value]="committedRange()"
                             [(open)]="open"
                             [placeholder]="title()"
                             [shortcuts]="options().shortcuts ?? null"
                             [showBuiltinShortcuts]="options().showBuiltinShortcuts ?? true"
                             [totalRange]="options().totalRange ?? null"
                             (confirm)="apply($event)"
                             data-testid="filter-menu-bar-date-range-dropdown" />
